import { apiGlobal } from './index'
import { LOCAL_STORAGE } from '@utils/Const'

const getAccessToken = () => localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN)

export const learnEndPoints = {
  SPEECH_CHECK: 'iesv/api/v1/check/speech',
}

const learnRequest = {
  getSpeechCheck: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(learnEndPoints.SPEECH_CHECK, params, {}, true)
    }
    return apiGlobal.post(learnEndPoints.SPEECH_CHECK, params, {}, true)
  },
}

export default learnRequest
